/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import Select from 'react-select';

import _find from 'lodash/find';

import Translate from '../../../components/Translate';

import { LocaleChange } from '../../../actions/common/actions-common';

class SelectLanguageTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curLocale: {}
    };
  }

  componentDidMount() {
    let locale = _find(this.props.locales, {value: this.props.locale});

    if (locale) this.setState({curLocale: locale});
  }

  _onLocaleSelect = (locale) => {
    this.setState({curLocale: locale});

    this.props.LocaleChange(locale.value);
  }

  render() {
    return (<div id="select_language">
      <label> <Translate content="settings.tabs.language.select_language" /> </label>
      <Select
          value={{...this.state.curLocale}}
          onChange={this._onLocaleSelect}
          options={this.props.locales}
          placeholder="Select an option"
      />
    </div>);
  }
}

SelectLanguageTab.propTypes = {
  locales: PropTypes.array,
  locale: PropTypes.string
};

const mapStateToProps = function ({common: {locales, locale}}, ownProps) {

  return {locales, locale};
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({LocaleChange}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectLanguageTab);



// WEBPACK FOOTER //
// ./src/containers/Settings/Tabs/select-language.js